import Swiper from "swiper/bundle";

var homeSlider;

function createhomeSlider(tbs) {
    const sw = tbs.querySelector(".swiper");
    const buttons = tbs.querySelectorAll(".home-btn");

    function updateActiveButton(activeIndex) {
        buttons.forEach((btn, index) => {
            if (index === activeIndex) {
                btn.classList.add("active");
            } else {
                btn.classList.remove("active");
            }
        });
    }

    homeSlider = new Swiper(sw, {
        slidesPerView: 1,
        speed: 600,
        grabCursor: false,
        allowTouchMove: false,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        on: {
            slideChange: function () {
                updateActiveButton(this.activeIndex);
            }
        }
    });

    buttons.forEach((button) => {
        button.addEventListener("click", () => {
            const index = button.getAttribute("data-index");
            homeSlider.slideTo(index);
            updateActiveButton(parseInt(index));
        });
    });
}


function inithomeSlider() {

    const homeVar = document.querySelector(".home-slider");
    if (homeVar) {
        createhomeSlider(homeVar)
    }
}
export { inithomeSlider }





 